import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {Background} from '@mintdata/mint-kit/api/models/background/Background';
import {BackgroundType} from '@mintdata/mint-kit/api/models/background/BackgroundType';
import {Border} from '@mintdata/mint-kit/api/models/Border';
import {BorderFill} from '@mintdata/mint-kit/api/models/BorderFill';
import {BorderRadius} from '@mintdata/mint-kit/api/models/BorderRadius';
import {BorderStyle} from '@mintdata/mint-kit/api/models/BorderStyle';
import {BoxShadow} from '@mintdata/mint-kit/api/models/BoxShadow';
import {ColorWithVisibility} from '@mintdata/mint-kit/api/models/ColorWithVisibility';
import {PositiveUnits} from '@mintdata/mint-kit/api/models/PositiveUnits';
import {Units} from '@mintdata/mint-kit/api/models/Units';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {BeanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/BeanConfig';
import {PositiveUnitsConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/PositiveUnitsConfig';

export class ScrollbarModel
{
    @Property<ABoolean>({
        title: 'Enable Custom Scrollbar',
        tip: `Enable Custom Scrollbar`,
        isRequired: false,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    isEnabled?:ABoolean;

    @Property<PositiveUnits>({
        title: 'ScrollbarModel Width',
        tip: 'ScrollbarModel Width',
        isRequired: true,
        typeConfig: PositiveUnitsConfig,
        typeCtor: PositiveUnits
    })
    width:PositiveUnits;

    @Property<Background>({
        title: 'Track Background',
        tip: 'Track Background',
        isRequired: true,
        typeConfig: BeanConfig,
        typeCtor: Background
    })
    trackBackground:Background = Background.default();

    @Property<Border>({
        title: 'Track Border',
        tip: 'Track Border',
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: Border
    })
    trackBorder:Border;

    @Property<BoxShadow>({
        title: 'Track Shadows',
        tip: 'Track Shadows',
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: BoxShadow
    })
    trackShadow?:BoxShadow = BoxShadow.default();

    @Property<Background>({
        title: 'Thumb Background',
        tip: 'Thumb Background',
        isRequired: true,
        typeConfig: BeanConfig,
        typeCtor: Background
    })
    thumbBackground:Background = Background.default();

    @Property<Border>({
        title: 'Thumb Border',
        tip: 'Thumb Border',
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: Border
    })
    thumbBorder:Border;

    @Property<BoxShadow>({
        title: 'Thumb Shadows',
        tip: 'Thumb Shadows',
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: BoxShadow
    })
    thumbShadow?:BoxShadow = BoxShadow.default();

    public constructor(isEnabled?:ABoolean,
                       width?:PositiveUnits,
                       trackBackground?:Background,
                       trackBorder?:Border,
                       trackShadow?:BoxShadow,
                       thumbBackground?:Background,
                       thumbBorder?:Border,
                       thumbShadow?:BoxShadow)
    {
        this.isEnabled = isEnabled;
        this.width = width;
        this.trackBackground = trackBackground;
        this.trackBorder = trackBorder;
        this.trackShadow = trackShadow;
        this.thumbBackground = thumbBackground;
        this.thumbBorder = thumbBorder;
        this.thumbShadow = thumbShadow;
    }

    public static default():ScrollbarModel
    {
        const background = (hex:string, opacity:number) => new Background(
            BackgroundType.solid(),
            ColorWithVisibility.fromHexAlpha(hex, opacity),
            ColorWithVisibility.white(),
            ColorWithVisibility.black(),
            ANumber.fromNumber(0),
        );

        const shadow = new BoxShadow(
            ColorWithVisibility.fromHexAlpha('#000', .2, false),
            Units.fromPixels(0),
            Units.fromPixels(0),
            PositiveUnits.fromPixels(4),
            Units.fromPixels(0)
        );

        return new ScrollbarModel(
            ABoolean.false(),
            PositiveUnits.fromPixels(12),

            // track
            background('#fff',0.12),
            Border.default(),
            shadow,

            // thumb
            background('#000', 0.24),
            new Border(
                ColorWithVisibility.fromHexAlpha('#000', 0),
                PositiveUnits.fromPixels(3),
                BorderStyle.solid(),
                BorderRadius.fromEqualPixels(6),
                BorderFill.all()
            ),
            shadow,
        );
    }
}
